import * as React from 'react'

import { EnvironmentContext } from 'config/environment'
import { sessionExpired } from 'initializers/axiosInterceptors'

import { Session, useGetCurrentSession } from 'modules/core/hooks/useGetCurrentSession'

export const SessionContext = React.createContext<Session | null>(null)

const Provider = ({ children }: React.PropsWithChildren) => {
  const environment = React.useContext(EnvironmentContext)
  const {
    loading,
    access,
    company,
    employee,
    email,
    isAdminBecome,
    isStaffBecome,
    isIntercomAllowed,
    allMyDescendants,

    // FIXME: Stop adding new policies to this hook!!!!!!
    canManageTimeoff,
    canManageSubscription,
    canSeeEmployeeProfile,
    canCreateEmployees,
    canCreateTeams,
    canRequestUpsell,
    canSeeProductUpdates,
    canSelfUpsell,
  } = useGetCurrentSession()

  if (loading) return null

  if (!access || !company || !employee) {
    sessionExpired(environment)
    return null
  }

  const session = {
    access,
    company,
    employee,
    email,
    isAdminBecome,
    isStaffBecome,
    isIntercomAllowed,
    allMyDescendants,

    // FIXME: Stop adding new policies to this hook!!!!!!
    canManageTimeoff,
    canManageSubscription,
    canSeeEmployeeProfile,
    canCreateEmployees,
    canCreateTeams,
    canRequestUpsell,
    canSeeProductUpdates,
    canSelfUpsell,
  }

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>
}

interface Props {
  isBookkeeperView?: boolean
}

export const SessionProvider = ({ isBookkeeperView, children }: React.PropsWithChildren<Props>) => {
  if (isBookkeeperView) {
    return <>{children}</>
  }

  return <Provider>{children}</Provider>
}
